import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import TnmwtmWallet from "./TnmwtmWallet"
import TnmwtmSubscriptionGift from "./TnmwtmSubscriptionGift"
import classes from "./TnmwTopupModal.module.scss"

const TnmwTopupModal = props => {
  const {
    openTopupModal,
    setOpenTopupModal
  } = props

  const [t] = useTranslation()

  const [tab, setTab] = useState("topup")

  return (
    <Modal
      show={openTopupModal}
      onHide={() => setOpenTopupModal(false)}
      backdrop="static"
      centered
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <button
            onClick={() => setTab("topup")}
            className={clsx(
              classes["header-item"],
              tab === "topup" && classes["active"]
            )}
          >
            {t("افزایش_اعتبار")}
          </button>

          <button
            onClick={() => setTab("subscriptionGift")}
            className={clsx(
              classes["header-item"],
              tab === "subscriptionGift" && classes["active"]
            )}
          >
            {t("کد_هدیه_اشتراک")}
          </button>
        </div>

        {
          tab === "topup" &&
          <TnmwtmWallet
            setOpenTopupModal={setOpenTopupModal}
          />
        }

        {
          tab === "subscriptionGift" &&
          <TnmwtmSubscriptionGift
            setOpenTopupModal={setOpenTopupModal}
          />
        }
      </div>
    </Modal>
  )
}

export default TnmwTopupModal